import { Injectable } from '@angular/core';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { CoreDataService } from '../core.data';
import { AssignmentTypeEnum } from './enums';
import { Hotel } from './interfaces/entity.interface';
import { CustomEncoder } from '../http.util';
import { VersionConfigService } from '@app/core/services/version-config';
import { HotelGroupsResponse } from '@app/core/services/hotel-groups';
import { HttpOptions } from '@app/core/models/api.interface';

@Injectable({
  providedIn: 'root',
})
export class EntityHttpService {
  private _versionBasedUrlPrefix: string;

  constructor(
    private _coreDataService: CoreDataService,
    private _versionConfigService: VersionConfigService,
  ) {
    this._versionBasedUrlPrefix = '';
    this._versionConfigService.getVersion('entity').subscribe((prefix) => {
      this._versionBasedUrlPrefix = `${prefix}/entity/`;
    });
  }

  getAllHotelsByAccount(
    assignmentType: AssignmentTypeEnum,
    webUserId?: string,
  ) {
    const headers = new HttpHeaders();
    const options: HttpOptions = {
      headers,
      withCredentials: true,
      params: null,
    };
    options.params = new HttpParams({ encoder: new CustomEncoder() })
      .set('id', webUserId!)
      .set('type', assignmentType);

    return this._coreDataService.get<any>(
      `${this._versionBasedUrlPrefix}`,
      options,
    );
  }

  saveEntityAccessForUser(webUserId: string, assignedEntities: Array<Hotel>) {
    const headers = new HttpHeaders();
    const body = {
      WebUserId: webUserId,
      entities: assignedEntities,
    };
    const options = {
      headers,
      withCredentials: true,
    };

    return this._coreDataService.post<any>(
      `${this._versionBasedUrlPrefix}`,
      body,
      options,
    );
  }

  getHotelGroupsByWebUserId(id: string) {
    const headers = new HttpHeaders();
    const options = {
      headers,
      withCredentials: true,
      params: null,
    };

    options.params = this._coreDataService.generatePlatformQueryParameters(
      new HttpParams({
        encoder: new CustomEncoder(),
      }),
      { id },
    );

    return this._coreDataService.get<HotelGroupsResponse>(
      `${this._versionBasedUrlPrefix}groups`,
      options,
    );
  }

  updatePrimaryHotelGroupForUser(webUserId: string, hotelGroupId: string) {
    const headers = new HttpHeaders();
    const body = {
      WebUserId: webUserId,
      hotelGroupId,
    };
    const options = {
      headers,
      withCredentials: true,
    };

    return this._coreDataService.post<any>(
      `${this._versionBasedUrlPrefix}groups/primary`,
      body,
      options,
    );
  }

  deleteHotelGroupForUser(webUserId: string, hotelGroupId: string) {
    const headers = new HttpHeaders();
    const body = {
      WebUserId: webUserId,
      hotelGroupId,
    };
    const options = {
      headers,
      withCredentials: true,
    };

    return this._coreDataService.post<any>(
      `${this._versionBasedUrlPrefix}groups/delete`,
      body,
      options,
    );
  }

  saveHotelGroupForUser(webUserId: string, hotelGroup: any) {
    const headers = new HttpHeaders();
    const body = {
      WebUserId: webUserId,
      hotelGroup,
    };
    const options = {
      headers,
      withCredentials: true,
    };

    return this._coreDataService.post<any>(
      `${this._versionBasedUrlPrefix}groups/custom`,
      body,
      options,
    );
  }
}
